"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeRetryStatus = exports.OtpChallengeChannel = exports.ChallengeType = void 0;
var ChallengeType;
(function (ChallengeType) {
    ChallengeType["OTP"] = "OTP";
    ChallengeType["OTP_LOGIN"] = "OTP_LOGIN";
    ChallengeType["TRUSTED_CONFIRMATION"] = "BIOMETRIC_TRUSTED_CONFIRMATION";
    ChallengeType["TRUSTED_CONFIRMATION_LOGIN"] = "BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN";
    ChallengeType["SIGNATURE_KEY"] = "SIGNATURE_KEY";
    ChallengeType["OTP_IVR"] = "OTP_IVR";
    ChallengeType["SIGNATURE_KEY_IVR"] = "SIGNATURE_KEY_IVR";
    ChallengeType["BIOCHECK"] = "BIOCHECK";
    ChallengeType["FOUR_EYES"] = "FOUR_EYES";
    ChallengeType["NONE"] = "None";
})(ChallengeType || (exports.ChallengeType = ChallengeType = {}));
var OtpChallengeChannel;
(function (OtpChallengeChannel) {
    OtpChallengeChannel["EMAIL"] = "EMAIL";
    OtpChallengeChannel["SMS"] = "SMS";
    OtpChallengeChannel["PUSH"] = "PUSH";
})(OtpChallengeChannel || (exports.OtpChallengeChannel = OtpChallengeChannel = {}));
var ChallengeRetryStatus;
(function (ChallengeRetryStatus) {
    ChallengeRetryStatus["DEFAULT"] = "NO_LIMIT";
    ChallengeRetryStatus["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
    ChallengeRetryStatus["LIMIT_REACHED"] = "LIMIT_REACHED";
})(ChallengeRetryStatus || (exports.ChallengeRetryStatus = ChallengeRetryStatus = {}));
//# sourceMappingURL=types.js.map